import React from 'react';
import BenefitList from '../components/BenefitList';
import AdminLayout from 'cms/core/shared/AdminLayout';
import { Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

function BenefitScreen() {
  return (
    <AdminLayout pageTitle="Benefits">
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/cms" color="inherit">
            Home
          </MuiLink>
          <MuiLink component={Link} to="/cms/settings" color="inherit">
            Settings
          </MuiLink>
          <Typography color="text.primary">Benefits</Typography>
        </Breadcrumbs>
        <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
          Benefits
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage employee benefits and perks
        </Typography>
      </Box>
      <BenefitList />
    </AdminLayout>
  );
}

export default BenefitScreen;
